import React from "react"

import { PostEmailVerificationPage } from "./PostEmailVerificationPage"
import { usePostEmailVerificationPageModel } from "./hooks/usePostEmailVerificationPageModel"

export const PostEmailVerificationPageConnector = React.memo(() => {
  return <PostEmailVerificationPage {...usePostEmailVerificationPageModel()} />
})
